import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class UserService {
  addManagersShop(idShop, idUser) {
    return api.post(
      UtilsUrl.UserPosURL() + "/addManagersShop/" + idShop + "/" + idUser
    );
  }
  deleteManagersShop(idShop, idManager) {
    return api.put(
      UtilsUrl.UserPosURL() + "/deleteManagersShop/" + idShop + "/" + idManager
    );
  }
  getAllManagersByShop(idUser, idShop) {
    return api.get(
      UtilsUrl.UserPosURL() + "/getAllManagersByShop/" + idUser + "/" + idShop
    );
  }
  getAllManagersToSelect(idUser) {
    return api.get(UtilsUrl.UserPosURL() + "/getAllManagersToSelect/" + idUser);
  }
}
export default new UserService();
